// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Table_TheComp__bQ1NO"};